/**
 * @desc 员工管理
 * @created: 2020/09/18
 * @author: Colorfule
 * @version : v1.0
 */
import request from '@/plugins/http'
import qs from 'qs';

// 列表查询
export const getListData = (params) => {
  return request.get('/user/list', params)
}

// 获取用户的id
export const getUserId = params => {
  return request.get('/user/id', params);
}

// 获取用户详情
export const getUserDetails = params => {
  return request.get('/user/details', params)
}

// 保存新增用户
export const postUserSave = data => {
  return request.post('/user/save', qs.stringify(data))
}

// 修改用户详情
export const postUserEdit = data => {
  return request.post('/user/update', qs.stringify(data))
}

// 获取用户下的商户/供应商
export const getDetailsList = params => {
  return request.get('/user/details/list', params)
}

// 冻结/解冻账号
export const freezeAndUnfreeze = data => {
  return request.put('/user/freezeAndUnfreeze', qs.stringify(data))
}

// 根据用户id查询该员工的业务数据
export const listUserBusinessData = params => {
  return request.get('/user/details/listUserBusinessData', params);
}

// 根据勾选合计员工的业务数据
export const countUserBusinessData = data => {
  return request.post('/user/details/countUserBusinessData', data, { json: true })
}
